import React, { createContext, useState, useEffect } from "react";
import axios from "axios";

export const CartContext = createContext();

export const CartProvider = ({ children }) => {
  const [cartCount, setCartCount] = useState(0);

  const userId = localStorage.getItem("userId") || "10";
  const deviceId = localStorage.getItem("deviceId") || "web";

  // Function to fetch cart count
  const fetchCartCount = async () => {
    try {
      const response = await axios.get(
        `https://dharajwebbackend.concentics.com/api/get_cartdata/${deviceId}/${userId}`
      );

      if (response.data?.status === "success" && Array.isArray(response.data.cart)) {
        const count = response.data.cart.reduce(
          (sum, item) => sum + Number(item.proquantity || 0),
          0
        );
        setCartCount(count);
      }
    } catch (err) {
      console.error("Failed to fetch cart count:", err);
      const storedCount = localStorage.getItem("cartCount");
      if (storedCount) setCartCount(Number(storedCount));
    }
  };

  // Fetch cart count initially
  useEffect(() => {
    fetchCartCount();

    // Refresh every second
    const interval = setInterval(() => {
      fetchCartCount();
    }, 1000);

    return () => clearInterval(interval); // Clean up interval on unmount
  }, [deviceId, userId]);

  // Keep localStorage in sync
  useEffect(() => {
    localStorage.setItem("cartCount", cartCount);
  }, [cartCount]);

  // Increment count properly (as number)
  const incrementCartCount = (qty = 1) => setCartCount(prev => Number(prev) + Number(qty));
  const setCartCountDirectly = (count) => setCartCount(Number(count));

  return (
    <CartContext.Provider value={{ cartCount, incrementCartCount, setCartCountDirectly }}>
      {children}
    </CartContext.Provider>
  );
};
